<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="flex items-center mb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Dokumen Pra-Presentasi PJP Baru
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div
              class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
              style="min-height: 60vh"
            >
              <div class="row">
                <div
                  class="col-md-6 d-flex justify-content-start"
                  style="padding-left: 2rem; padding-top: 0.5rem"
                >
                  <img
                    src="../../../assets/images/borneo-indobara-icon.png"
                    alt=""
                    style="width: 15%; height: auto"
                  />
                </div>
                <div
                  class="col-md-6 d-flex justify-content-end"
                  style="padding-right: 2rem; padding-top: 0.5rem"
                >
                  <p class="fs-5 fw-bold" style="">BIB-HSE-PPO-F-096-05</p>
                </div>
              </div>
              <div class="container p-4">
                <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                  DAFTAR RIWAYAT HIDUP CALON PJO
                </h1>
                <p
                  class="text-center fs-8 mb-3"
                  style="font-family: 'Inter-Regular'"
                >
                  Formulir ini untuk memberi informasi mengenai daftar riwayat
                  hidup calon PJO
                </p>
                <p class="fs-8 mb-2" style="font-family: 'Inter-Regular'">
                  Saya yang bertanda tangan di bawah ini:
                </p>

                <!-- form di sini -->
                <form action="#">
                  <!-- <div class="row mb-1">
                          <div class="col-md-12">
                              <p class="text-danger fst-italic fs-8 fw-bold">
                                  * Wajib diisi
                              </p>
                          </div>
                      </div> -->
                  <div class="row mb-2">
                    <div class="col-md-6">
                      <label for="nama" class="form-label fs-8 fw-bold"
                        >Nama</label
                      >
                      <p class="form-label fs-8">{{ formValues.nama }}</p>
                    </div>
                    <div class="col-md-6">
                      <label for="tempatLahir" class="form-label fs-8 fw-bold"
                        >Tempat Lahir</label
                      >
                      <p class="form-label fs-8">
                        {{ formValues.tempatLahir }}
                      </p>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-md-6">
                      <label for="tanggalLahir" class="form-label fs-8 fw-bold"
                        >Tanggal Lahir</label
                      >
                      <p class="form-label fs-8">
                        {{
                          moment(formValues.tanggalLahir).format("DD MMM YYYY")
                        }}
                      </p>
                    </div>
                    <div class="col-md-6">
                      <label for="nik" class="form-label fs-8 fw-bold"
                        >NIK</label
                      >
                      <p class="form-label fs-8">{{ formValues.nik }}</p>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label for="jabatan" class="form-label fs-8 fw-bold"
                        >Jabatan</label
                      >
                      <p class="form-label fs-8">
                        {{ formValues.jabatan }}
                      </p>
                    </div>
                    <div class="col-md-6">
                      <label for="perusahaan" class="form-label fs-8 fw-bold"
                        >Perusahaan</label
                      >
                      <p class="form-label fs-8">
                        {{ kontraktor.namaKontraktor }}
                      </p>
                    </div>
                  </div>
                  <div class="row mb-5">
                    <div class="col-md-6">
                      <label for="kantorPusat" class="form-label fs-8 fw-bold"
                        >Alamat Kantor Pusat</label
                      >
                      <p class="form-label fs-8">
                        {{ formValues.alamatKantorPusat }}
                      </p>
                    </div>
                    <div class="col-md-6">
                      <label for="kantorSite" class="form-label fs-8 fw-bold"
                        >Alamat Kantor Site</label
                      >
                      <p class="form-label fs-8">
                        {{ formValues.alamatKantorSite }}
                      </p>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="">
                      <p
                        class="text-start"
                        style="
                          font-family: 'Inter-Thin';
                          font-size: 0.9rem;
                          letter-spacing: 0.1rem;
                          font-weight: bold;
                        "
                      >
                        RIWAYAT PENDIDIKAN
                      </p>
                    </div>
                    <!-- loop riwayat pendidikan -->
                    <div
                      class="row mb-2"
                      v-for="(row, index) in formValues.pendidikan"
                      :key="index"
                      :class="{ 'border-top pt-2': index > 0 }"
                    >
                      <div class="col-md-6">
                        <label
                          for="lembagaPendidikan"
                          class="form-label fs-8 fw-bold"
                          >Nama Lembaga Pendidikan</label
                        >
                        <p class="form-label fs-8">
                          {{ row.nama_lembaga }}
                        </p>
                      </div>
                      <div class="col-md-3">
                        <label
                          for="tahunPendidikan"
                          class="form-label fs-8 fw-bold"
                          >Tahun Mulai</label
                        >
                        <p class="form-label fs-8">{{ row.tahun }}</p>
                      </div>
                      <div class="col-md-3">
                        <label
                          for="tahunPendidikanSelesai"
                          class="form-label fs-8 fw-bold"
                          >Tahun Selesai</label
                        >
                        <p class="form-label fs-8" v-if="!row.till_now">
                          {{ row.tahun_selesai }}
                        </p>
                        <p class="form-label fs-8" v-else>Sampai Sekarang</p>
                      </div>
                    </div>
                    <!-- end of loop riwayat pendidikan -->
                  </div>
                  <div class="row">
                    <p
                      class="mb-1"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      RIWAYAT PEKERJAAN
                    </p>
                    <!-- loop riwayat pekerjaan -->
                    <div
                      class="row mb-2"
                      v-for="(row, index) in formValues.pekerjaan"
                      :key="index"
                      :class="{ 'border-top pt-2': index > 0 }"
                    >
                      <div class="col-md-6">
                        <label
                          for="nama_perusahaan"
                          class="form-label fs-8 fw-bold"
                          >Nama Perusahaan</label
                        >
                        <p class="form-label fs-8">
                          {{ row.nama_perusahaan }}
                        </p>
                      </div>
                      <div class="col-md-3">
                        <label
                          for="tahunPekerjaan"
                          class="form-label fs-8 fw-bold"
                          >Tahun Mulai</label
                        >
                        <p class="form-label fs-8">{{ row.tahun }}</p>
                      </div>
                      <div class="col-md-3">
                        <label
                          for="tahunPekerjaanSelesai"
                          class="form-label fs-8 fw-bold"
                          >Tahun Selesai</label
                        >
                        <p class="form-label fs-8" v-if="!row.till_now">
                          {{ row.tahun_selesai }}
                        </p>
                        <p class="form-label fs-8" v-else>Sampai Sekarang</p>
                      </div>
                      <div class="col-md-6 mb-2">
                        <label
                          for="jabatanPerusahaan"
                          class="form-label fs-8 fw-bold"
                          >Jabatan</label
                        >
                        <p class="form-label fs-8">{{ row.jabatan }}</p>
                      </div>
                    </div>
                    <!-- end loop riwayat pekerjaan -->
                  </div>
                  <div class="row mb-3 mt-2">
                    <p
                      class="mb-1"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      RIWAYAT PELATIHAN/KOMPETENSI
                    </p>
                    <div
                      class="row mb-2"
                      v-for="(row, index) in formValues.kompetensi"
                      :key="index"
                      :class="{ 'border-top pt-2': index > 0 }"
                    >
                      <div class="col-md-6">
                        <label for="pelatihan" class="form-label fs-8 fw-bold"
                          >Pelatihan</label
                        >
                        <p class="form-label fs-8">
                          {{ row.nama_pelatihan }}
                        </p>
                      </div>
                      <div class="col-md-3">
                        <label
                          for="tahunPelatihan"
                          class="form-label fs-8 fw-bold"
                          >Tahun Mulai</label
                        >
                        <p class="form-label fs-8">{{ row.tahun }}</p>
                      </div>
                      <div class="col-md-3">
                        <label
                          for="tahunPelatihanSelesai"
                          class="form-label fs-8 fw-bold"
                          >Tahun Selesai</label
                        >
                        <p class="form-label fs-8" v-if="!row.till_now">
                          {{ row.tahun_selesai }}
                        </p>
                        <p class="form-label fs-8" v-else>Sampai Sekarang</p>
                      </div>
                    </div>
                    <div
                      v-if="fileSertifikat != '' && fileSertifikat != null"
                      class="fs-8 row mb-2"
                    >
                      <div class="col-md-6">
                        <b>Nomor Sertifikat PJO : {{ nomorSertifikatPjo }}</b>
                      </div>
                      <div class="col-md-6">
                        <b>File Sertifikat Pelatihan/Kompetensi :</b>
                        <ul>
                          <li v-for="(asse, idx) in fileSertifikat" :key="idx">
                            <a
                              class="text-danger pointer"
                              @click="viewFile(asse.filename)"
                              >{{ asse.actual_name }}</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                    Demikian daftar riwayat hidup ini saya buat untuk digunakan
                    sebagaimana mestinya.
                  </p>

                  <div class="row mb-5">
                    <div class="col-md-3">
                      <label for="tempat" class="form-label fs-8 fw-bold"
                        >Tempat</label
                      >
                      <p class="form-label fs-8">{{ formValues.tempat }}</p>
                    </div>
                    <div class="col-md-3">
                      <label for="tanggal" class="form-label fs-8 fw-bold"
                        >Tanggal</label
                      >
                      <p class="form-label fs-8">
                        {{ moment(formValues.tanggal).format("DD MMM YYYY") }}
                      </p>
                    </div>
                  </div>
                  <div>
                    <p class="fs-8">Dimohon oleh,</p>
                  </div>
                  <div class="row mb-2">
                    <div class="col-md-6">
                      <label for="tandaTangan" class="form-label fs-8 fw-bold">
                        Tanda Tangan (png, jpg, jpeg)
                      </label>
                      <div v-if="fileTtd != ''" class="fs-8 mb-2">
                        <img :src="fileTtd" style="height: 5rem" />
                      </div>
                      <!-- <Vue3Signature  ref="signature1" :sigOption="state.option" :w="'100%'" :h="'85%'"
                              :disabled="state.disabled" class="example border"></Vue3Signature> -->
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label for="namaPimpinan" class="form-label fs-8 fw-bold"
                        >Nama Lengkap Calon PJO</label
                      >
                      <p class="form-label fs-8">{{ formValues.nama }}</p>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <div>
      <img
        src="../../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
  <!-- modal filter -->
</template>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "../../../GlobalDataMixin";
// import Datepicker from "vuejs3-datepicker"
import axios from "axios";
import {
  API_BASE_URL,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_SIO_GET_PJODET,
  CMS_VIEW_IMAGE,
  CMS_GET_KELENGKAPAN_SIO,
  CMS_GET_SIOID,
  CMS_VIEW_DOCUMENT,
} from "@/constants";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
//import Swal from "sweetalert2"

const url_get_pjodetail = API_BASE_URL + CMS_SIO_GET_PJODET;
const url_get_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;

export default {
  mixins: [GlobalDataMixin],
  name: "Form2View",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
  },
  data() {
    return {
      isLoading: true,
      id: null,
      sioID: null,
      idKelengkapan: null,
      fileSertifikat: null,
      nomorSertifikatPjo: null,
      formValues: {
        nama: "",
        tempatLahir: "",
        tanggalLahir: "",
        nik: "",
        jabatan: "",
        perusahaan: "",
        alamatKantorPusat: "",
        alamatKantorSite: "",
        tempat: "",
        tanggal: "",
        tandaTangan: "",
        pendidikan: [{ nama_lembaga: "", tahun: null, till_now: false }],
        pekerjaan: [
          {
            nama_perusahaan: "",
            tahun: null,
            nama_jabatan: "",
            till_now: false,
          },
        ],
        kompetensi: [{ nama_pelatihan: "", tahun: null, till_now: false }],
        ttd: "",
        namaTTD: "",
      },
      kontraktor: [],
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getPJODetail(this.id);
  },
  methods: {
    getPJODetail(idform) {
      axios
        .get(url_get_pjodetail + idform, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("getPJODetail", response);
          let dt = response.data.data;

          if (dt != null) {
            // this.formValues.nama = dt.nama;
            this.formValues.tempatLahir = dt.tempatLahir;
            // this.formValues.jabatan = dt.jabatan;
            this.formValues.tanggalLahir =
              dt.tanggalLahir != null
                ? moment(dt.tanggalLahir).format("YYYY-MM-DD")
                : null;
            this.formValues.nik = dt.nik;
            this.formValues.alamatKantorPusat = dt.alamatKantorPusat;
            this.formValues.alamatKantorSite = dt.alamatKantorSite;
            this.formValues.kompetensi = JSON.parse(dt.riwayatPelatihan);
            this.formValues.pendidikan = JSON.parse(dt.riwayatPendidikan);
            this.formValues.pekerjaan = JSON.parse(dt.riwayatPekerjaan);
            this.formValues.tempat = dt.tempat;
            this.formValues.tanggal =
              dt.tanggalTtd != null
                ? moment(dt.tanggalTtd).format("YYYY-MM-DD")
                : null;
            // this.formValues.namaTTD = dt.namaPengesah;
            this.$nextTick(function () {
              this.getKontraktor(dt.kontraktorId);
              this.getSioID(dt.kontraktorId);
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },
    getKontraktor(id) {
      axios
        .get(url_get_kontraktor + id, {
          headers: { accept: "application/json" },
        })
        .then((response) => {
          console.log(response);
          this.kontraktor = response.data.detailKontraktor;
          // set value form edit
          // this.url_icon = API_BASE_URL+CMS_VIEW_IMAGE+response.data.detailKontraktor.image;
          if (
            response.data.detailKontraktor.image != null ||
            response.data.detailKontraktor.image != ""
          ) {
            localStorage.setItem(
              "icon_kontraktor_cms",
              JSON.stringify({ icon: response.data.detailKontraktor.image })
            );
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data Detail Kontraktor : " + error.message);
          console.error("Error fetching data:", error.message);
        });
    },
    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response nya = ", response);

          let dt = null;
          dt = response.data.data;
          if (dt != null) {
            this.sioID = dt.id;
            this.getKelengkapan(this.sioID);
          }

          // this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    getKelengkapan(sio_id) {
      axios
        .get(url_get_kelengkapan + sio_id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);

          let ret_kel = response.data;
          this.idKelengkapan = ret_kel.id == null ? "" : ret_kel.id;
          this.fileSertifikat =
            ret_kel.assets != null && ret_kel.assets != ""
              ? JSON.parse(ret_kel.assets)
              : null;
          this.nomorSertifikatPjo = ret_kel.nomorSertifikatPjo;
          if (this.formValues.nama == null || this.formValues.nama == "") {
            this.formValues.nama =
              ret_kel.namaPjo == null ? "" : ret_kel.namaPjo;
          }
          if (
            this.formValues.jabatan == null ||
            this.formValues.jabatan == ""
          ) {
            this.formValues.jabatan =
              ret_kel.jabatanPjo == null ? "" : ret_kel.jabatanPjo;
          }
          if (
            this.formValues.namaTTD == null ||
            this.formValues.namaTTD == ""
          ) {
            this.formValues.namaTTD =
              ret_kel.namaAtasan == null ? "" : ret_kel.namaAtasan;
          }
          this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + ret_kel.ttdPjo;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKelengkapan : " + error.message);
          console.error("Error fetching data getKelengkapan :", error.message);
        });
    },
    viewFile(fileName) {
      window.open(url_view_document + fileName, "_blank");
    },
  },
};
</script>

<style scoped>
section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}

.btn_eform {
  background-color: #fff;
  border: #d0d5dd;
}
</style>
